import { Button, Card, Header, Image, Label } from "semantic-ui-react"
import React, { useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { searchVehicleByVin, selectVehicle } from "../../../../v1/actions/vehicles"
import store from "../../../../shared_component/utils/configureStore"
import placeholderCarImg from "../../../../images/placeholder_car.svg"
import { routerPaths } from "../../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import Notifications from "../../../../v1/components/Notifications"
import {
  gaJSON,
  serviceSelectedEvents,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"

const VehicleInfo = ({
  t,
  history,
  user,
  vehicle,
  handleSearchAgain,
  asModal,
  closeModalHandler
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isOilChangeService = localStorage.getItem("isOilChangeService") === "true" || false
  const isComparePriceFlow = localStorage.getItem("isComparePriceFlow") === "true" || false

  const handleToggleVehicleInfo = async () => {
    await store.dispatch(selectVehicle({}))
    if (handleSearchAgain) {
      handleSearchAgain()
    } else {
      history.goBack()
    }

    trackFirebaseAnalytics({
      event: gaJSON.EtoB_not_my_vehicle_click
    })
  }

  const handleVehicleSubmit = async () => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_it_is_my_vehicle_click
    })
    setIsSubmitting(true)
    if (vehicle.id === user.activeVehicleId) {
      if (isComparePriceFlow) {
        console.log("wefr")
        history.push({
          pathname: routerPaths.reviewAppointment
        })
      } else {
        history.push({
          pathname: routerPaths.shopSelection
        })
      }
    } else {
      const success = await store.dispatch(searchVehicleByVin(vehicle.vin, true))
      if (typeof success === "boolean") {
        setIsSubmitting(false)

        if (asModal) {
          closeModalHandler && closeModalHandler()
          return
        }
        if (isComparePriceFlow) {
          replaceHistoryAndGoForward(routerPaths.reviewAppointment)
        } else if (isOilChangeService) {
          replaceHistoryAndGoForward(routerPaths.shopSelection)
        } else {
          replaceHistoryAndGoForward(routerPaths.selectService)
        }
      } else {
        trackFirebaseAnalytics({
          event: gaJSON.EtoB_vehicle_submit_error
        })
        store.dispatch(
          Notifications.error({
            title: t("errorLbl"),
            message: success.toString(),
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
        setIsSubmitting(false)
      }
    }
  }

  const replaceHistoryAndGoForward = (route) => {
    history.replace({
      pathname: route
    })
    history.go(-1)
    setTimeout(
      () =>
        history.replace({
          pathname: route
        }),
      0
    )
  }

  return (
    <Card className="vehicle-info-card" raised={true}>
      <div className="vehicle-info">
        <Header as="h3">{t("isThisYourVehicle")}</Header>
        <Image src={vehicle.dashboard_url || placeholderCarImg} width="250" height="187.5" />
        <Label>
          {vehicle.year} {vehicle.make} {vehicle.model}
        </Label>
      </div>
      <div className="action-button">
        <Button
          fluid
          onClick={handleVehicleSubmit}
          loading={isSubmitting}
          disabled={isSubmitting}
          className="primary-button"
        >
          {t("continue")}
        </Button>

        <Button
          fluid
          basic
          color="black"
          onClick={handleToggleVehicleInfo}
          loading={false}
          disabled={isSubmitting}
          className="secondary-button"
        >
          {t("notRightUpdate")}
        </Button>
      </div>
    </Card>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let vehicle = state.selectedVehicle.selectedVehicle || {}

  return {
    user: user,
    vehicle
  }
}

export default withRouter(connect(mapStateToProps)(withTranslation("vehicleDetails")(VehicleInfo)))
